import type { StopTime } from './gtfs-ressource';

export interface TripUpdate {
  /** First service day the update applies to, `YYYYMMDD`. */
  date: string;
  /** Last service day it applies to, included; absent for the single day of `date`. */
  end_date?: string | null;
  group_id: string;
  gtfs_id: string;
  trip_id: string;

  comment: string | null;
  delay: number;
  is_canceled: boolean;
  skipped_stop_time_seqs: number[];
  stop_infos: StopInfo[] | null;
  shape: Array<[number, number]>;
  delays: Array<Delay>;
  temporary_stops: Array<DeviationStop>;
}

export interface DeviationStop {
  arrival_time: number;
  departure_time: number;
  last_stop_delta?: number;
  reference_stop_sequence?: number; // used to know which stop is the reference for the delta
  stop_sequence: number;
  stop_lat: number;
  stop_lon: number;
  stop_name: string;
  stop_id: string;
  type: StopType;
}

export enum StopType {
  /** existing stop in trip, with modified latlong (from backend) */
  SHIFT = 'SHIFT',
  /** existing stop in gtfs, reused for this trip (from backend)*/
  REUSE = 'REUSE',
  /** non existing stop in gtfs, new name & latlong (from backend) */
  AD_HOC = 'AD_HOC',
  /** regular stop, not modified, from gtfs and in default trip (from front) */
  REGULAR = 'REGULAR',
  /** not implemented yet */
  NEUTRALIZED = 'NEUTRALIZED', // not implemented yet
  /** Canceled stop (from front) */
  CANCELED = 'CANCELED',
}

interface Delay {
  stop_sequence: number;
  delay: number;
}

interface StopInfo {
  stop_sequence: number;
  information: string;
}

interface DelayedTrip {
  content: number;
  contentTime: string;
  contentDelayTime: string;
  isNegativeDelay: boolean;
}

export interface StopTimeWithType extends StopTime {
  type: StopType;
  name: string;
}

// types formatted
export interface FormatedUpdate {
  canceledTrip?: boolean;
  delayedTrip?: DelayedTrip;
  unservedStops?: UnservedStops;
  displacedStops?: TemporaryStops;
  temporaryStops?: TemporaryStops;
  shape?: Array<[number, number]>;
}

interface UnservedStops {
  content: number;
  contentDetail: number[];
}

interface TemporaryStops {
  content: number;
  contentDetail: DeviationStop[];
}
